import { atom } from "jotai";

/**
 * Is the user authenticated?
 */
export const isUserAuthenticated_atom = atom<boolean>(false);

/**
 * Keeps the app on the sign-in flow while a logout-triggered session query is
 * still resolving.
 */
export const isLocallySignedOutAtom = atom<boolean>(false);

/**
 * Pre Auth Path
 */

export const preAuthenticatedPath_atom = atom<null | string>(null);
